import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUserName } from '../../../../../features/auth/authSlice';
import { selectDealerId } from '../../../../../store/slices/userParamsSlice';

import { useAddVehicleAcceptanceFormMutation } from '../../../../../api/endpoints/vehicleAcceptenceForm';
import { formatDateForApi } from '../../../../../utils/dateUtils';
import { createVAFFieldHandlers } from './useVAFFormFieldHandlers';

export const useCreateVehicleAcceptanceForm = (refetchList) => {

    const customerName = useSelector(selectUserName);
    const dealerId = useSelector(selectDealerId);
    const [createDialogVisible, setCreateDialogVisible] = useState(false);
    const [createFormData, setCreateFormData] = useState({
        chassisNo: '',
        vehicleAcceptDate: null,
        vehicleAcceptKm: null,
        description: '',
        bosBranchCode: dealerId,
        customerName: customerName,
        isActive: true,
    });

    const [createSubmitted, setCreateSubmitted] = useState(false);

    const [addVehicleAcceptanceFormMutation, { isLoading: isCreating }] = useAddVehicleAcceptanceFormMutation();

    const openNew = () => {
        setCreateFormData({
            chassisNo: '',
            vehicleAcceptDate: null,
            vehicleAcceptKm: null,
            description: '',
            bosBranchCode: dealerId,
            customerName: customerName,
            isActive: true,
        });
        setCreateSubmitted(false);
        setCreateDialogVisible(true);
    };

    const hideCreateDialog = () => {
        setCreateDialogVisible(false);
        setCreateSubmitted(false);
    };

    const { onInputChange: onCreateInputChange, onNumberChange: onCreateNumberChange, onDateChange: onCreateDateChange, onDropdownChange: onCreateDropdownChange } =
        createVAFFieldHandlers(setCreateFormData);


    const handleCreate = () => {
        setCreateSubmitted(true);

        const { chassisNo, vehicleAcceptDate, vehicleAcceptKm, description, customerName, isActive } = createFormData;

        if (chassisNo && vehicleAcceptDate && vehicleAcceptKm !== null) {
            // Tarihi yerel gün bileşenleriyle "YYYY-MM-DD" formatına çevirerek gün kayması sorununu çöz
            const formattedVehicleAcceptDate = formatDateForApi(vehicleAcceptDate);

            const dataToSend = {
                chassisNo: chassisNo,
                vehicleAcceptDate: formattedVehicleAcceptDate,
                vehicleAcceptKm: vehicleAcceptKm,
                description: description,
                customerName: customerName,
                isActive: isActive,
            };

            addVehicleAcceptanceFormMutation(dataToSend)
                .unwrap()
                .then(() => {
                    hideCreateDialog();
                    refetchList();
                })
                .catch((error) => console.error("Create failed:", error));
        }
    };

    return {
        createDialogVisible,
        createFormData,
        setCreateFormData,
        onCreateInputChange,
        onCreateNumberChange,
        onCreateDateChange,
        onCreateDropdownChange,
        createSubmitted,
        isCreating,
        openNew,
        hideCreateDialog,
        handleCreate
    };
};